import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, of, take } from 'rxjs';
import { ClinicItemJSON } from '../common/models/server-response/clinic-item-json.model';
import { ClinicListItem } from '../common/models/users-data/clinic-list-item.model';
import { SelectClinicsSortingHeadersEnum } from '../dialogs/select-clinics-dialog/enums/select-clinics-sorting-headers-enum';
import { RequestsService } from './requests.service';
import { SortingDirectionsEnum } from 'src/common-panel/enums/sorting-directions-enum';
import { CountryId } from 'src/common-panel/constants/country-configs.constants';

@Injectable({
  providedIn: 'root'
})
export class ClinicService
{

  clinicList: ClinicListItem[] = []


  tableSettings: {
    sortingHeader: SelectClinicsSortingHeadersEnum;
    sortDirection: SortingDirectionsEnum;
    pageSize: number;
    pageIndex: number;
  } = {
      sortingHeader: SelectClinicsSortingHeadersEnum.id,
      sortDirection: SortingDirectionsEnum.none,
      pageSize: 20,
      pageIndex: 0,
    }

  filterTableByClinic: BehaviorSubject<string> = new BehaviorSubject<string>('')
  loadedClinicListSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  defualtClinicToUpdateSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)


  constructor(private requestsService: RequestsService) { }

  loadClinicListByCountry(country: CountryId): BehaviorSubject<boolean>
  {
    let l_loaded = new BehaviorSubject<boolean>(false)
    this.requestsService.loadClinicListByCountry(country).pipe(
      take(1),
      catchError(err => { return of([]) })
    ).subscribe(l_clinicList =>
    {
      let l_data: ClinicListItem[] = []

      l_clinicList.forEach(l_clinic =>
      {
        let l_checkedClinic = this.checkClinicData(l_clinic)
        if (l_checkedClinic)
        {
          l_data.push(l_checkedClinic)
        }

      })
      this.clinicList = l_data
      l_loaded.next(true)
      this.loadedClinicListSubject.next(true)
    })
    return l_loaded
  }

  checkClinicData(clinicListItem: ClinicItemJSON): ClinicListItem | null
  {

    if (!clinicListItem.shopId)
    {
      console.error(`Error: Clinic ${ JSON.stringify(clinicListItem) } hasn't ID.`)

      return null;
    }


    let l_clinicListItem: ClinicListItem = {
      city: clinicListItem.city,
      clinicName: clinicListItem.shopName ? clinicListItem.shopName : '',
      addressLine1: clinicListItem.addressLine1 ? clinicListItem.addressLine1 : '',
      addressLine2: clinicListItem.addressLine2 ? clinicListItem.addressLine2 : '',
      clinicId: clinicListItem.shopId
    }
    return l_clinicListItem;
  }

  clearClinicList()
  {
    this.clinicList = []
  }
}
